import React from 'react';
import PropTypes from 'prop-types';

import Payment from './Payment';

const Bill = (props) => {
  const { bill, amountText } = props;
  return (
    <li className="invoices-list__item invoice">
      <Payment bill={bill} />
      <div className="holder">
        <div className="invoice__number invoices">
          {bill.displayDescription}
        </div>
        <p className="invoice__description">
          {bill.paymentDescription}
        </p>
        <div className="invoice__amount ">
          {amountText} &#8381;
        </div>
      </div>
    </li>
  );
};

Bill.propTypes = {
  bill: PropTypes.shape({
    displayDescription: PropTypes.string,
    paymentDescription: PropTypes.string,
    amount: PropTypes.number,
  }).isRequired,
  amountText: PropTypes.string.isRequired,
};
Bill.defaultProps = {};

export default Bill;



// WEBPACK FOOTER //
// ./src/components/Modal/Payment/Bill.js